import { StatusInscription } from '@/enum/StatusInscription';
import Vue from 'vue'

export const statusInscription = (value: number) => {    
    switch(value){
        case StatusInscription.inscrit: return "inscrit";
        case StatusInscription.present: return "présent";
        case StatusInscription.abscent: return "abscent";
        case StatusInscription.annulee: return "annulé";
        case StatusInscription.attente: return "liste attente";
    } 
    return "";    
}
Vue.filter('statusInscription', statusInscription)